import { Pipe, PipeTransform } from '@angular/core';

// Generieke " - inactive"-marker achter een label (rol, functienaam, ...) in lijst-rijen — naast de
// opacity-dimming van de lijst-tools (list-item--inactive, list.scss) geeft dit ook zonder kleurwaarneming een tekstueel
// onderscheid. Eén pipe i.p.v. de @if-conditie in elke tablist-template te herhalen.
// De marker zelf, ook los te gebruiken als het label uit meerdere delen bestaat (bv. "naam (e-mail)"):
// de marker hoort dan achter het geheel, niet tussen naam en e-mail.
export const inactiveSuffixText = ' - inactive';

@Pipe({
    name: 'inactiveSuffix',
    standalone: true,
})
export class InactiveSuffixPipe implements PipeTransform {

    transform(label: string | null | undefined, inactive: boolean | null | undefined): string {
        if (!label) return '';
        return inactive ? `${label}${inactiveSuffixText}` : label;
    }
}
